import { Serializable } from "./serializable";

export class CharacteristicType implements Serializable<CharacteristicType> {
  private _uuid = "";
  public code = "";

  /**
   * Gets entity id
   * @returns entity id
   */
  getId(): string {
    return this._uuid;
  }

  /**
   * Transforms received object to CharacteristicType entity
   * @param input
   * @returns CharacteristicType entity
   */
  deserialize(input: any = {}): CharacteristicType {
    if (!input) {
      return null;
    }

    const properties = Object.getOwnPropertyNames(this);
    Object.keys(input).forEach((key) => {
      if (input[key] !== null) {
        switch (key) {
          case "uuid":
            this._uuid = input[key];
            break;
          default:
            if (properties.includes(key)) {
              this[key] = input[key];
            }
            break;
        }
      }
    });

    return this;
  }

  /**
   * Transforms CharacteristicType entity to json object
   * @returns json object
   */
  public serialize(): any {
    const output = {};

    Object.getOwnPropertyNames(this).forEach((property) => {
      switch (property) {
        case "_id":
          if (this[property]) {
            output["uuid"] = this[property];
          }
          break;
        default:
          output[property] = this[property];
          break;
      }
    });

    return output;
  }
}
